export const VEHICLE_CATEGORY_OPTIONS = [
  { label: '\u8fc7\u8f66', value: '1' },
  { label: '\u95f8\u673a\u8f66\u8f86', value: '2' },
  { label: '\u8fdb\u573a', value: '3' },
  { label: '\u51fa\u573a', value: '4' }
]

export function createStatisticTableRows(dates, categories, results) {
  const normalizedDates = dates.map(date => String(date))
  return categories.map((category, index) => {
    const result = results[index] || {}
    const data = result.data || {}
    const keys = data.statisticKey || []
    const values = data.statisticValue || []
    const valueMap = {}
    const categoryName = category.label || category.name || String(category.value || '')
    const row = {
      categoryName,
      category: categoryName
    }

    keys.forEach((key, keyIndex) => {
      valueMap[String(key)] = values[keyIndex] == null ? 0 : values[keyIndex]
    })
    normalizedDates.forEach(date => {
      row[date] = valueMap[date] == null ? 0 : valueMap[date]
    })
    return row
  })
}

export function getSelectedOptionLabel(options, value, defaultLabel) {
  const option = options.find(item => item.value === value)
  return option ? option.label : defaultLabel
}



// WEBPACK FOOTER //
// ./src/views/tjfx/statisticTable.js